import React from "react";
function FormPreview() {
  return (
    <main className="mainsection">
      <div className="preview">NO PREVIEW AVAILABLE</div>
    </main>
  );
}
export default FormPreview;
